import React from "react";
import Logo from "../img/logo-fundo-branco.png"

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          
          <a className="page-scroll " href="/">
            <img className="img-rounded" src={Logo} width={120} alt="" /> 
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            
            {/* <li>
              <a href="#features" className="page-scroll">
                Como funciona?
              </a>
            </li> */}
            <li>
              <a href="#about" className="page-scroll">
               Quem Somos
              </a>
            </li>
             <li>
              <a href="#services" className="page-scroll">
               Horário de Cultos
              </a>
            </li>

            {/* <li>
              <a href="#faq" className="page-scroll">
              Perguntas Frequentes
              </a>
            </li> */}
            <li>
              <a href="#comunhao" className="page-scroll">
                Comunhão
              </a>
            </li>
            <li>
              <a href="#maps" className="page-scroll">
                Onde Estamos
              </a>
            </li>
            {/* <li>
              <a href="#team" className="page-scroll">
                Onde Estamos
              </a>
            </li> */}
            <li>
              <a href="#contact" className="page-scroll">
                Contato
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
